export const ContactData = [
  {icon: 'fas fa-map-marker-alt', tipoDeDatos: 'Dirección: ', datos: 'Rúa da Encarnación - 17  Celanova, Ourense', link: ''},
  {icon: 'fas fa-phone-alt', tipoDeDatos: 'Teléfono: ', datos: '988-43-19-33', link: ''},
  {icon: 'far fa-envelope', tipoDeDatos: 'Email: ', datos: 'hola@peluquerianovolook.com', link: ''},
  {icon: 'fab fa-whatsapp', tipoDeDatos: 'WhatsApp: ', datos: '647-98-40-78', link: ''},
  // tslint:disable-next-line: max-line-length
  {icon: 'fab fa-facebook', tipoDeDatos: 'Facebook', datos: 'siguenos en facebook', link: 'https://es-es.facebook.com/pages/category/Hair-Salon/Peluqueria-Novo-Look-558953924114616/'},
  {icon: 'fab fa-instagram', tipoDeDatos: 'Instagram', datos: 'siguenos en instagram', link: 'https://www.instagram.com/peluquerianovolook/?hl=es'},
];
